import { useState } from 'react'
import omit from 'lodash-es/omit'

import { EMPTY_LIST, EMPTY_OBJECT } from '../../../../constants/common'
import { GretaAIChatRowStatus } from '../../GretaAIChat.constants'
import { getIsGretaAIChatRowNewReply } from '../../GretaAIChat.utils'

import {
  getGretaAIChatMergedRowStatusById,
  setGretaAIChatRowStatus,
} from './useGretaAIChatRowStatus.utils'

export function useGretaAIChatRowStatus({ chats = EMPTY_LIST } = EMPTY_OBJECT) {
  const [chatStatusById, setChatStatusById] = useState(EMPTY_OBJECT)

  function markChatGenerating(chatId) {
    setChatStatusById(current =>
      setGretaAIChatRowStatus({
        chatId,
        status: GretaAIChatRowStatus.Generating,
        statusById: current,
      })
    )
  }

  function markChatSettled(chatId, { delivered, isBackground }) {
    setChatStatusById(current =>
      delivered && isBackground
        ? setGretaAIChatRowStatus({
            chatId,
            status: GretaAIChatRowStatus.NewReply,
            statusById: current,
          })
        : omit(current, chatId)
    )
  }

  function clearChatUnread(chatId) {
    setChatStatusById(current =>
      getIsGretaAIChatRowNewReply(current[chatId])
        ? omit(current, chatId)
        : current
    )
  }

  return {
    chatStatusById: getGretaAIChatMergedRowStatusById(chatStatusById, chats),
    clearChatUnread,
    markChatGenerating,
    markChatSettled,
  }
}
